import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CaptionService } from '../shared-services/caption.service';

export interface BreadCrumb {
  position: number;
  label: string;
  url: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: 'src/app/utils/breadcrumb/breadcrumb.html',
    styleUrls: ['src/app/utils/breadcrumb/breadcrumb.css'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: BreadCrumb[] = [];
  paramName: any;
  id: any;
  name: any;
  extra: any;

  constructor(
    @Inject(Router) private router: Router,
    @Inject(ActivatedRoute) private activatedRoute: ActivatedRoute,
    @Inject(CaptionService) public captions: CaptionService
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute, 0);
  }

  public ngOnInit(): void {}

  buildBreadCrumb(route: ActivatedRoute, position: number): BreadCrumb[] {
    this.id = route.snapshot.params.pathId ?? null;
    this.name = route.snapshot.params.pathName ?? null;
    this.extra = route.snapshot.params.pathExtra ?? null;

    let label: string;
    let path: string;

    this.paramName = route.snapshot.params['displayName'] ?? route.snapshot.params['pathName'];

    if (position === 1) {
      path = route.routeConfig?.data?.['parent']?.path ?? '/home';
      label = route.routeConfig?.data?.['parent']?.name
        ? this.captions.captions[route.routeConfig.data['parent'].name]
        : 'Null';
    } else {
      if (this.paramName) {
        label = route.routeConfig?.data?.breadcrumb
          ? this.captions.captions[route.routeConfig.data.breadcrumb] + ' ' +
            this.captions.captions['for'] + ' ' +
            this.paramName
          : 'Null';
      } else {
        label = route.routeConfig?.data?.breadcrumb
          ? this.captions.captions[route.routeConfig.data.breadcrumb]
          : 'Null';
      }

      path = route.routeConfig?.path ?? '/home';
    }

    const breadcrumb: BreadCrumb = {
      label,
      url: path,
      position
    };

    this.breadcrumbs.push(breadcrumb);

    if (route.routeConfig?.data?.['parent']?.name !== '' && position !== 1) {
      return this.buildBreadCrumb(route, 1);
    }

    return this.breadcrumbs;
  }

  navigate(crumb: BreadCrumb): void {
    if (crumb.url.includes('inventoryCounter')) {
      return;
    }

    if (crumb.url.includes(':pathId')) {
      crumb.url = crumb.url.replace(':pathId', this.id);
    }

    if (crumb.url.includes(':pathName')) {
      crumb.url = crumb.url.replace(':pathName', this.name);
    }

    if (crumb.url.includes(':pathExtra')) {
      crumb.url = crumb.url.replace(':pathExtra', this.extra);
    }

    if (this.breadcrumbs.length > 1) {
      this.router.navigate([crumb.url]);
    }
  }
}
